class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      const rawQuery = this.input.value;
      const displayQuery = this.toDisplaySearchQuery(rawQuery);
      this.input.value = displayQuery;
      if (displayQuery !== rawQuery) this.updateSearchDisplayText(rawQuery, displayQuery);
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.form.addEventListener('submit', this.onNmsSearchSubmit.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toDisplaySearchQuery(value) {
    const query = value.trim();
    if (query.toLowerCase() === 'tag:"gender: men" and (jogger or sweatpants)') return 'mens joggers';
    if (query.toLowerCase() === 'tag:"gender: women" and tag:"category: jeans"') return "women's jeans";

    const colorDressMatch = query.match(/^tag:"Category: Dress" AND variants\.title:([a-z]+)$/i);
    if (colorDressMatch) return colorDressMatch[1].toLowerCase() + ' dress';

    return value;
  }

  updateSearchDisplayText(rawQuery, displayQuery) {
    document.querySelectorAll('[role="status"]').forEach((status) => {
      if (status.textContent?.includes(rawQuery)) {
        status.textContent = status.textContent.replace(rawQuery, displayQuery);
      }
    });

    if (document.title.includes(rawQuery)) {
      document.title = document.title.replace(rawQuery, displayQuery);
    }
  }

  toStrictSearchQuery(value) {
    const query = value.trim();
    const normalized = query.toLowerCase().replace(/’/g, "'");
    const dressColors = [
      'black',
      'white',
      'red',
      'blue',
      'green',
      'pink',
      'yellow',
      'purple',
      'orange',
      'brown',
      'beige',
      'ivory',
      'navy',
      'maroon',
      'gold',
      'silver',
      'grey',
      'gray',
    ];
    const colorDressMatch =
      normalized.match(/^([a-z]+)\s+dress(?:es)?$/) || normalized.match(/^dress(?:es)?\s+([a-z]+)$/);

    if (colorDressMatch && dressColors.includes(colorDressMatch[1])) {
      const color = colorDressMatch[1] === 'gray' ? 'grey' : colorDressMatch[1];
      return 'tag:"Category: Dress" AND variants.title:' + color;
    }

    const mensJoggerQueries = [
      'mens joggers',
      "men's joggers",
      'men joggers',
      'mens jogger',
      "men's jogger",
      'men jogger',
      'joggers mens',
      "joggers men's",
      'joggers men',
      'jogger mens',
      "jogger men's",
      'jogger men',
    ];

    const womensJeansQueries = [
      'womens jeans',
      "women's jeans",
      'women jeans',
      'womens jean',
      "women's jean",
      'women jean',
      'jeans womens',
      "jeans women's",
      'jeans women',
    ];

    if (mensJoggerQueries.includes(normalized)) {
      return 'tag:"Gender: Men" AND (jogger OR sweatpants)';
    }

    if (womensJeansQueries.includes(normalized)) {
      return 'tag:"Gender: Women" AND tag:"Category: Jeans"';
    }

    return query;
  }

  onNmsSearchSubmit() {
    const strictQuery = this.toStrictSearchQuery(this.input.value);
    if (strictQuery) this.input.value = strictQuery;
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
